<res-login (loginCallback)="login()"></res-login>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/login/login.component.ts.LoginComponent.html